import { getDateTimeNow } from "../helpers/DateHelper";
import { callAPI, postAPI } from "../services/api";

export const getWorkOrders = async (storeId, date, filters = {}, lastScannedWO) => {
  let route;
  const queryFilters = new URLSearchParams(filters).toString();
  route = `workOrders/${storeId}?inputTimeExpected=${date}&${queryFilters}&lastScannedWO=${lastScannedWO}`;
  try{
    const response = await callAPI(route);
    if (Array.isArray(response)) return response;

    if (response.version !== undefined) {
      const receivedVersion = response.version;
      const savedVersion = localStorage.getItem("backendVersion");
      if (savedVersion == null) {
        localStorage.setItem("backendVersion", receivedVersion);
      } else if (savedVersion !== receivedVersion) {
        localStorage.setItem("backendVersion", receivedVersion);
        window.location.reload();
      }
    }

    return response;
  }catch(error){
    console.log('==Error in workOrderService',error);
    throw error
  }
};

export const getNonPrintedOrEmailedWorkOrders = async (storeId, date, filters = {}, lastScannedWO) => {
  const res = await getWorkOrders(storeId, date, filters, lastScannedWO); 
  let workOrders = res.workOrders.filter((wo) => !wo.ServiceDate)
  lastScannedWO = res.newLastScannedWO
  return {workOrders, lastScannedWO};
}

export const getWorkOrder = async (storeId, workOrderId) => {
  const route = `workorder/${storeId}/${workOrderId}`
  const response = await callAPI(route);
  
  if(!response) {
    throw new Error(`The work Order ${workOrderId} was not found`)
  }
  return response;
}

export const trackModified = async (storeId, workOrderId) => {
    const route = `trackModified`;
    const body = { body: { storeId, workOrder: workOrderId } };
    await postAPI("", route, body);
    console.log(`Modification reported for ${storeId} - ${workOrderId}`);
};

export const trackPrint = async (printLog, printOption, isSourcePrint) => {
    const route = `trackPrint`;
    const body = {
      body: {
        storeId: printLog.storeId,
        workOrder: printLog.workOrderId,
        printOption: printOption,
        categories: printLog.categories,
        additionalNotes : printLog.additionalNotes,
        isSourcePrint: isSourcePrint
      }
    };
    const response = await postAPI("", route, body);
    return response.json();
};

export const getPrintedReport = async (storeId, workOrderId) => {
  const route = `printed/${storeId}/${workOrderId}`;
  const response = await callAPI(route);
  return response;
};

export const getHistoricalData = async (license, state, storeId) => {
  try {
    if(license && state) {
      const route = `historical/by-license-plate/${license}/${state}?usePreviousInspection=true`;
      return await callAPI(route);
    }
  } catch(error) {
    console.log('Error retrieving historical data:', error);
  }
};

export const trackWorkOrderNotFound = async (storeId, lastFourWOid) => {
  const dateReported = getDateTimeNow({});
  const route = 'ingestWorkOrderNotFound';

  const body = {
    storeId: storeId,
    lastFourWOid: lastFourWOid,
    recordDate: dateReported
  }

  try{
    const response = await postAPI("", route, body);
    console.log(`WorkOrder not found reported for ${storeId} - Last WO Ids: ${lastFourWOid}`)
    return response;
  }catch(error){
    console.error('An error occurred during notification of WO not found.')
    throw error;
  }
}
